<template>
  <div v-if="widgetId && numericProductId">
    <ClientOnly>
      <div
        class="yotpo-widget-instance"
        :data-yotpo-instance-id="widgetId"
        :data-yotpo-product-id="numericProductId"
        :data-yotpo-cart-product-id="numericProductId"
        data-yotpo-section-id="product"
      />
    </ClientOnly>
  </div>
</template>

<script setup>
const props = defineProps({
  product: {
    type: Object,
    default: null,
  },
});

const { $getCurrentLocaleConfig } = useNuxtApp();

const widgetId = computed(() => $getCurrentLocaleConfig()?.yotpoStarRatingWidgetId || null);

const numericProductId = computed(() => {
  const id = props.product?.id;
  if (!id) return null;
  return String(id).split('/').pop() || null;
});

const initYotpoWidgets = async () => {
  await nextTick();
  globalThis.yotpoWidgetsContainer?.initWidgets?.();
};

onMounted(() => {
  if (widgetId.value && numericProductId.value) initYotpoWidgets();
});

watch([widgetId, numericProductId], ([id, pid]) => {
  if (id && pid) initYotpoWidgets();
});
</script>
